
import ProfileVideo from "./components/ProfileVideo.vue";
import CompanyProfile from "./components/CompanyProfile.vue";
import Banner from "./components/Banner.vue";
import Story from "./components/Story.vue";
import {
  flatTreeData,
  findParentElements,
  getBreadList,
} from "~/utils/index.js";
const bannerData = [
  {
    src: "/img/his.png",
    title: "Our history",
    year: "2016",
    content: `Brilliant sound and design motivate everything we do.We have a deep passion for building beautifully crafted, technically sophisticated sound tools.`,
  },
  {
    src: "/img/his.png",
    title: "Our history",
    year: "2017",
    content: `Brilliant sound and design motivate everything we do.We have a deep passion for building beautifully crafted, technically sophisticated sound tools.`,
  },
  {
    src: "/img/his.png",
    title: "Our history",
    year: "2018",
    content: `Brilliant sound and design motivate everything we do.We have a deep passion for building beautifully crafted, technically sophisticated sound tools.`,
  },
  {
    src: "/img/his.png",
    title: "Our history",
    year: "2019",
    content: `Brilliant sound and design motivate everything we do.We have a deep passion for building beautifully crafted, technically sophisticated sound tools.`,
  },
];
export default {
  asyncData({ app, route, store }) {
    const pageBannerbg =
      encodeURI(app.$websiteDataHelper.getMenuItemBanner("contact-us")) ||
      "/img/about-us-bg.png";

    const aboutMenus = store.state.menu.filter(m => m.type === "about-us");

    const path = `/${route.path.split("/")[1]}`;
    const currentVO = app.$websiteDataHelper.getCurrentVO(aboutMenus, path);

    const replaceAllOccurrences = (sourceStr, searchStr, replacement) => {
      const regex = new RegExp(searchStr, "g");
      return sourceStr.replace(regex, replacement);
    };
    let result = "";
    if (currentVO.content) {
      result = replaceAllOccurrences(
        currentVO.content,
        "sandbox",
        `sandbox="allow-scripts allow-same-origin allow-presentation"`,
      );
    }

    const flatArray = flatTreeData(aboutMenus);
    const breadList = findParentElements(route.meta[0].nodeid, flatArray);
    return {
      banner: currentVO?.bannerurl || "/img/about-us-bg.png",
      bannerData,
      title: currentVO?.name_ch,
      result,
      breadList,
      currentVO,
    };
  },
  head() {
    const { path, meta } = this.$route;
    const { menu, baseJsonLd } = this.$store.state.jsonLd;
    const siteUrl = baseJsonLd.url;
    const breadList = getBreadList(menu, this.currentVO, 1);

    const jsonld = {
      ...baseJsonLd,
      name: meta?.title,
      description: meta?.description,
      keywords: meta?.keywords,
      url: new URL(path, siteUrl).toString(),
    };

    return {
      script: [
        {
          type: "application/ld+json",
          json: [
            jsonld,
            {
              "@context": "https://schema.org",
              "@type": "BreadcrumbList",
              itemListElement: breadList,
            },
          ],
        },
      ],
    };
  },
  components: { ProfileVideo, CompanyProfile, Banner, Story },
};
